var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFollowUpReq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1EBCB4",
    fillOpacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 9.99984H20V8.6665H18.6667V9.99984H13.3333V8.6665H12V9.99984H11.3333C10.5933 9.99984 10 10.5932 10 11.3332V20.6665C10 21.0201 10.1405 21.3593 10.3905 21.6093C10.6406 21.8594 10.9797 21.9998 11.3333 21.9998H20.6667C21.4 21.9998 22 21.3998 22 20.6665V11.3332C22 10.9795 21.8595 10.6404 21.6095 10.3904C21.3594 10.1403 21.0203 9.99984 20.6667 9.99984ZM20.6667 20.6665H11.3333V13.3332H20.6667V20.6665ZM16 14.6665V15.9998H18.6667V17.9998H16V19.3332L13.3333 16.9998L16 14.6665Z",
    fill: "#1EBCB4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpReq);
export default __webpack_public_path__ + "static/media/follow_up_req.e58803c33b5daf9fa946635d30edcc6e.svg";
export { ForwardRef as ReactComponent };